<template>
    <div class="w-full">
        <div class="w-full">
            <div class="card border-2 p-4 pb-0 bg-white hover:border-secondary transition duration-300">
                <div class="flex flex-row flex-no-wrap justify-between">
                    <div>
                        <picture v-if="paperCourse.cover_image.jpg_url">
                            <source :srcset="paperCourse.cover_image.webp_url" type="image/webp" />
                            <source :srcset="paperCourse.cover_image.jpg_url" type="image/jpg" />
                            <img
                                :src="paperCourse.cover_image.jpg_url"
                                :alt="paperCourse.paper_course_title"
                                class="w-full"
                                loading="lazy"
                            />
                        </picture>
                        <div class="missing-sco-image-wrapper" v-else>
                            <div class="missing-sco-image">
                                {{ paperCourse.paper_course_title }}
                            </div>
                        </div>
                        <h2 class="text-sm font-medium my-4 text-light-grey h-12 overflow-auto">
                            {{ paperCourse.paper_course_title }}
                        </h2>
                        <div class="h-8">
                            <h3 class="text-xs" v-if="hasCareOf">{{ careOf }}</h3>
                        </div>
                    </div>
                    <div class="pl-4 text-right text-light-grey">
                        <ul class="text-primary icon-list">
                            <li v-if="certificateAllowed" class="icon-list-item">
                                <paper-course-certificate
                                    :paper-course-user-id="paperCourse.paper_course_user_id"
                                    class="icon-wrapper"
                                ></paper-course-certificate>
                            </li>
                            <li :title="statusText" class="icon-list-item">
                                <div class="icon-wrapper">
                                    <component class="h-6 w-6" :is="statusIconComponentName" />
                                </div>
                            </li>
                            <li v-if="score" class="text-xs text-center">Score<br />{{ score }}%</li>
                            <li v-if="certificateAllowed" class="text-xs text-center">
                                {{ statusText }}<br />{{ dateFinished }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-6"></div>
    </div>
</template>

<script>
import slugify from "slugify";
import PaperCourseMixin from "@/components/courses/PaperCourseMixin";

export default {
    name: "PaperCourseCard",
    mixins: [PaperCourseMixin],
    props: {
        paperCourse: {
            type: Object,
            required: true
        }
    },
    computed: {
        hasCareOf() {
            return this.paperCourse.group_id || this.paperCourse.subgroup_id || this.paperCourse.virtual_group_id;
        },
        careOf() {
            if (this.paperCourse.virtual_group_id) {
                let virtualGroup = this.$store.getters.getVirtualGroupById(this.paperCourse.virtual_group_id);
                if (virtualGroup) {
                    return virtualGroup.title;
                }
            }

            if (this.paperCourse.subgroup_id) {
                let subgroup = this.$store.getters.getSubgroupById(this.paperCourse.subgroup_id);
                if (subgroup) {
                    return subgroup.title;
                }
            }

            if (this.paperCourse.group_id) {
                let group = this.$store.getters.getGroupById(this.paperCourse.group_id);
                if (group) {
                    return group.title;
                }
            }

            return "";
        }
    },
    methods: {
        slugify(title) {
            return slugify(title, { lower: true, strict: true, locale: "en" });
        }
    }
};
</script>
